import { createContext, useContext } from "react"

import { TableColumnRegistryContextValues } from "./Table.types"

// `any` is used here as workaround because it is not possible to create a context with a generic type
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const TableColumnRegistryContext = createContext<TableColumnRegistryContextValues<any> | undefined>(undefined)
TableColumnRegistryContext.displayName = "TableColumnRegistry"

export default function useTableColumnRegistry<T>(): TableColumnRegistryContextValues<T> {
    const context = useContext(TableColumnRegistryContext)
    if (!context) {
        throw new Error("useTableColumnRegistry must be used within a TableColumnRegistryContext provider")
    }

    return context as TableColumnRegistryContextValues<T>
}
